import "../../../../../app/common-components/custom-components.style.scss";
import "../styles.scss";


const AccessTable = ({ tableHeaders, body, onChange, type }) => {
  return (
    <>
      <div className="table_wrapper config_cover">
        <table className="table-hover">
          <thead>
            {tableHeaders.map((headers) => (
              <tr className="thead">
                {headers?.map((header) => (
                  <th
                    key={`${header.text}${header.key}`}
                    className={
                      header?.className ? `${header.className}` : "thead"
                    }
                    rowSpan={header?.rowSpan}
                    colSpan={header?.colSpan}
                    width={header?.width}
                  >
                    {header.text}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {Object.keys(body)?.map((key, index) =>
              body[key].map((row, index) => (
                <tr key={`tr${index}`}>
                  {row.category && index === 0 && (
                    <td rowSpan={body[key].length} className={"pane-header blank"}>
                      {row.category}
                    </td>
                  )}
                  <td className={row?.className ? row.className : ""}>
                    {row.value}
                  </td>

                  {tableHeaders[1].map((header, index) => (
                    <td
                      className={
                        header?.noDataCenter ? "" : "text-center tdico"
                      }
                    >
                      {type ? (
                        <div className="radio align-radio">
                          <label className="radio_container">
                            <input
                              name={header.text}
                              type={"radio"}
                              value={
                                row.category
                                  ? `${row?.category?.toLowerCase()}_${
                                      row.value
                                    }`
                                  : row.value
                              }
                              checked={row?.[header.text]}
                              onChange={onChange}
                            />
                            <span className="radio_checkmark"></span>
                          </label>
                        </div>
                      ) : (
                        <input
                          name={header.text}
                          className={"form-check-input"}
                          type={"checkbox"}
                          value={
                            row.category
                              ? `${row?.category?.toLowerCase()}_${row.value}`
                              : row.value
                          }
                          checked={row?.[header.text]}
                          disabled={row?.[`${header.text}_disable`]}
                          onChange={onChange}
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default AccessTable;
